export default __webpack_public_path__ + "static/covid-press-Outlook The News Scroll-9e9c9f36c4f64117686175a1ee880121.png";